export const SUPPORTED_LANGS = ['de', 'en', 'fr', 'it', 'es'];
export const LANG_LABELS = { de: 'Deutsch', en: 'English', fr: 'Français', it: 'Italiano', es: 'Español' };

const UI = {
  de: {
    nav: { home: 'Startseite', solutions: 'Lösungen', services: 'Was wir tun', references: 'Referenzen', platforms: 'Plattformen', pricing: 'Preise', cta: 'Beratung anfragen' },
    pilot: {
      title: 'Pilotkunde werden',
      subtitle: '{product} ist bald verfügbar. Tragen Sie sich ein – wir melden uns persönlich bei Ihnen, und als Pilotkunde profitieren Sie von Vorzugskonditionen.',
      name: 'Name', company: 'Firma', email: 'E-Mail', phone: 'Telefon', optional: '(optional)',
      product: 'Branche / Produkt', submit: 'Anfrage senden', sending: 'Wird gesendet…',
      success: 'Vielen Dank! Wir haben Ihre Anfrage erhalten und melden uns persönlich bei Ihnen.',
      error: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut oder schreiben Sie an info@invictaflow.ch.',
      required: 'Bitte Name und gültige E-Mail angeben.',
    },
    footer: {
      tagline: 'Web-Apps & Automationen für Schweizer KMU. Weniger Büroarbeit, mehr Zeit für Ihre Kunden.',
      navigation: 'Navigation', servicesTitle: 'Leistungen',
      servicesList: ['Web-Anwendungen', 'Automationen', 'Datenmanagement', 'Support'],
      notice: 'Diese Website sowie die zugrunde liegende Softwareplattform werden von der {company} entwickelt, betrieben und lizenziert.',
      rights: 'Alle Rechte vorbehalten.', privacy: 'Datenschutz', terms: 'AGB', imprint: 'Impressum', admin: 'Admin',
      close: 'Schliessen', legalBinding: 'Hinweis: Die deutsche Fassung ist rechtlich massgebend.',
    },
    cookie: {
      title: 'Datenschutz & Cookies',
      text: 'Wir verwenden Cookies und speichern personenbezogene Daten, um Ihre Erfahrung zu verbessern. Unser KI-Kontaktformular nutzt KI-Dienste zur Verarbeitung Ihrer Anfragen. Durch die Nutzung dieser Website stimmen Sie unserer {privacy} zu.',
      privacyLink: 'Datenschutzerklärung', acceptAll: 'Alle akzeptieren', necessary: 'Nur notwendige', learnMore: 'Mehr erfahren',
    },
    contact: {
      title: 'Kontakt', subtitle: 'Unser KI-Assistent hilft Ihnen, Ihr Projekt zu beschreiben',
      infoTitle: 'Kontaktinformationen', email: 'E-Mail', phone: 'Telefon', location: 'Standort', country: 'Schweiz',
      responseTitle: 'Antwortzeit', responseText: 'Wir antworten in der Regel innerhalb von 24 Stunden.',
    },
    notFound: { title: 'Seite nicht gefunden', text: 'Die gesuchte Seite existiert nicht oder wurde verschoben.', home: 'Zur Startseite' },
    projects: { more: 'Mehr erfahren', functions: 'Funktionen', technologies: 'Technologien', liveDemo: 'Live Demo ansehen' },
    services: { eyebrow: 'Was wir für Sie tun', example: 'Beispiel:' },
    pricing: { eyebrow: 'Preise', included: 'Was ist enthalten?', from: 'ab' },
    hero: { badgeBooking: 'Neue Buchung automatisch bestätigt', badgeOffer: 'Offerte erstellt – ohne Handarbeit' },
    seo: {
      title: 'Software & Branchenlösungen für Schweizer KMU | InvictaFlow',
      description: 'InvictaFlow entwickelt Websites, Web-Apps und Automatisierungen für Schweizer KMU sowie modulare Software für termin-, kurs- und buchungsbasierte Betriebe.',
      products: {
        care: {
          title: 'InvictaCare – Physiotherapie- & Praxissoftware Schweiz | InvictaFlow',
          description: 'Praxissoftware für Physiotherapie, Therapie & Massage: Verordnungen, Terminbuchung, Sitzungszähler, Heimübungen und Abrechnung über MediData. Schweizer Lösung, DSG-konform.',
        },
        fit: {
          title: 'InvictaFit – Fitnessstudio-Software Schweiz | Abos, Kurse & App',
          description: 'Fitnessstudio-Software aus der Schweiz: Online-Buchung, Mitgliederverwaltung, Abos & Punkte, Kursplan, Check-in, TWINT – inklusive eigener Studio-App.',
        },
        dance: {
          title: 'InvictaDance – Tanzschul-Software Schweiz | InvictaFlow',
          description: 'Software für Tanzschulen: Kursprogramme mit Leveln & Semestern, Blockanmeldung, Paar- & Kinderanmeldung, Guthaben & 10er-Karten, Events mit Tickets, Warteliste mit Auto-Nachrücken.',
        },
        beauty: {
          title: 'InvictaBeauty – Salon-Software für Coiffeur, Kosmetik & Nails Schweiz | InvictaFlow',
          description: 'Salon-Software ohne Provision: Online-Buchung ohne Konto, Einwirkzeiten, Anzahlung & No-Show-Gebühr, Behandlungskartei mit Fotos & Farbrezepturen, Kasse mit Tagesabschluss, Gutscheine.',
        },
        dental: {
          title: 'InvictaDental – Software für Zahnarztpraxis & Dentalhygiene Schweiz | InvictaFlow',
          description: 'Zahnarzt-Software aus der Cloud: Recall per WhatsApp, Online-Buchung, digitale Anamnese, Zahnschema (FDI), Abrechnung DENTOTAR & Tarif 222, Kostenvoranschlag mit digitaler Freigabe.',
        },
        auto: {
          title: 'InvictaAuto – Werkstatt-Software für Garagen & Reifenservice Schweiz | InvictaFlow',
          description: 'Garagen-Software: Werkstattauftrag, Freigabe von Zusatzarbeiten per WhatsApp mit Foto, Fahrzeugakte & Serviceheft, Service- & MFK-Erinnerung, Reifenhotel mit Online-Slots, QR-Rechnung.',
        },
      },
    },
    productPage: { other: 'Weitere Lösungen' },
    finder: {
      eyebrow: 'Branchen-Finder',
      title: 'In welcher Branche sind Sie zuhause?',
      subtitle: 'Wählen Sie Ihre Branche – wir führen Sie direkt zur passenden Lösung.',
      industries: {
        care: 'Physiotherapie, Therapie & Massage',
        fit: 'Fitness, EMS & Personal Training',
        dance: 'Tanzschule',
        beauty: 'Coiffeur, Kosmetik & Nails',
        dental: 'Zahnarztpraxis & Dentalhygiene',
        auto: 'Garage, Werkstatt & Reifenservice',
      },
      other: 'Andere Branche?',
      otherText: 'Kein Problem – wir entwickeln Ihre individuelle Lösung: massgeschneiderte Web-App, Online-Buchung, KI und Automatisierung für Ihren Betrieb.',
      otherCta: 'Projektanfrage starten',
    },
    form: {
      unavailableTitle: 'Kontaktieren Sie uns direkt',
      unavailableText: 'Das Online-Anfrageformular ist zurzeit nicht verfügbar. Schreiben Sie uns eine E-Mail oder rufen Sie uns an – wir melden uns innerhalb von 24 Stunden.',
      startTitle: 'Projektanfrage starten',
      startText: 'Unser KI-Assistent führt Sie Schritt für Schritt durch die Anfrage und stellt nur relevante Fragen.',
      consent: 'Ich habe die {terms} und die {privacy} gelesen und akzeptiere diese.',
      termsLabel: 'AGB', privacyLabel: 'Datenschutzerklärung',
      start: 'Jetzt starten',
      consentHint: 'Bitte bestätigen Sie zuerst die AGB und die Datenschutzerklärung.',
      analyzingTitle: 'Wir analysieren Ihre Firma …',
      analyzingText: 'Handelsregister (Zefix) und Webseite werden geprüft, damit wir Ihnen die passenden Fragen stellen können.',
      momentTitle: 'Einen Moment …', momentText: 'Ihr persönlicher Assistent wird vorbereitet.',
      companyTitle: 'Erzählen Sie uns von Ihrer Firma',
      companyText: 'Wir suchen Ihre Firma im Handelsregister (Zefix) und werfen einen Blick auf Ihre Webseite – so kennen wir Ihr Unternehmen bereits, bevor wir über Ihre Idee sprechen.',
      companyNameLabel: 'Firmenname', companyNamePh: 'z.B. InvictaX Group GmbH',
      websiteLabel: 'Webseite', optional: '(optional)', websitePh: 'z.B. www.ihre-firma.ch',
      analyzeBtn: 'Firma analysieren & weiter', skipBtn: 'Keine Firma / Privatperson',
      thanksTitle: 'Vielen Dank!', registryFound: 'im Handelsregister gefunden',
      questionLabel: 'Frage', yourAnswer: 'Ihre Antwort', answerPh: 'Ihre Antwort hier eingeben...',
      processing: 'Verarbeite Antwort...', next: 'Weiter', step: 'Schritt {n} von ~9',
      err503: 'Der KI-Assistent ist momentan nicht verfügbar. Bitte kontaktieren Sie uns direkt per E-Mail an info@invictaflow.ch.',
      err429: 'Zu viele Anfragen. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
      errGeneric: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder schreiben Sie uns an info@invictaflow.ch.',
    },
    platforms: {
      title: 'Unsere Plattformen',
      intro: 'Sämtliche Softwareplattformen und die digitale Infrastruktur werden von der InvictaX Group GmbH entwickelt, betrieben und lizenziert.',
      audiencePrefix: 'Zielgruppe:', trust: 'Entwickelt, betrieben und lizenziert durch die InvictaX Group GmbH',
      toPlatform: 'Zur Plattform', ctaTitle: 'Ihre eigene Plattform?',
      ctaText: 'Wir entwickeln massgeschneiderte Softwarelösungen für Ihr Unternehmen – von der Idee bis zum laufenden Betrieb.',
      ctaBtn: 'Projekt besprechen',
      items: {
        'strongfit-studio': {
          category: 'SaaS & Studio-Management',
          purpose: 'Komplette Management-Lösung für Fitness- und Wellness-Betriebe. Die Plattform digitalisiert den gesamten Studio-Alltag – von der Terminbuchung über das Kundenmanagement bis zu Abos und Zahlungen.',
          audience: 'Fitness-Studios, Personal Trainer und Wellness-Betriebe in der Schweiz',
          functions: ['Terminverwaltung & Online-Buchung', 'CRM & Kundenverwaltung', 'KI-gestützte Ernährungsanalyse', 'Abo- und Paketverwaltung', 'Zahlungen (Karte, TWINT, SEPA)', 'Passwortloser Login (E-Mail-Code & WhatsApp)'],
        },
        'reinmove': {
          category: 'Service & KI',
          purpose: 'KI-gestützte Offerten-Plattform für Reinigungsdienstleistungen. Kunden laden Fotos ihrer Räume hoch – die KI analysiert den Aufwand und liefert in unter 60 Sekunden einen transparenten Fixpreis.',
          audience: 'Privatpersonen und Firmen im Zürcher Oberland, die Umzugs- oder Unterhaltsreinigungen benötigen',
          functions: ['KI-Bildanalyse zur Aufwandsberechnung', 'Fixpreis-Offerte in unter 60 Sekunden', 'Abnahmegarantie für Umzugsreinigungen', 'Foto-Upload mit Verschmutzungs-Erkennung', 'Service-Gebiet-Validierung (PLZ-Radius)'],
        },
        'trucksonroad': {
          category: 'Events & Catering',
          purpose: 'Buchungs- und Anfrageplattform für Premium-Foodtrucks in der ganzen Schweiz – mit individueller 24h-Offerte, sechs Truck-Konzepten und kompletter Event-Koordination.',
          audience: 'Veranstalter von Festivals, Hochzeiten, Firmenanlässen und privaten Events',
          functions: ['Online-Anfragesystem mit 24h-Offerte', 'Sechs Foodtruck-Konzepte zur Auswahl', 'Event-Type-Routing (Hochzeit, Firma, Festival, Privat)', 'WhatsApp- und Rückruf-Integration', 'Admin-Bereich für Buchungen'],
        },
        'bellastrada': {
          category: 'Vermietung & Buchung',
          purpose: 'Digitale Vermietungsplattform für vollrestaurierte Fiat 500 Abarth Oldtimer – mit mehrstufigem Buchungsfluss, Dokumentenprüfung und Zahlungsabwicklung.',
          audience: 'Hochzeitspaare, Fotografen und Firmen, die einen Oldtimer für besondere Anlässe mieten möchten',
          functions: ['Mehrstufiger Buchungsassistent', 'Automatische Konto-Erstellung mit Dokumenten-Upload', 'Manueller Freigabe-Workflow für Admins', 'Zahlungslink (Karte, TWINT, Banküberweisung)', 'Fahrzeug-Verwaltung mit Verfügbarkeitskalender'],
        },
        'zo-werbeflaechen': {
          category: 'Out-of-Home Marketing',
          purpose: "Marktplatz für mobile Werbeanhänger im Zürcher Oberland. Firmen mieten Werbeflächen an Top-Standorten mit bis zu 15'000 Sichtkontakten pro Tag – regionale Firmen profitieren von 50% Rabatt.",
          audience: 'KMU, Vereine und Marketing-Verantwortliche im Zürcher Oberland',
          functions: ['Standort-Karte mit Verkehrsfrequenz-Anzeige', 'Automatische Firmen-Verifizierung via Handelsregister', 'Rabatt-Engine (ZO-Firmen 50%, Vereine gratis)', 'Buchung mit Verfügbarkeitsprüfung', 'Druckservice mit CMYK-Vorlagengenerator'],
        },
        'ch-buchhaltung': {
          category: 'Buchhaltung & KMU-Software',
          purpose: 'Schweizer Buchhaltungssoftware mit KI-gestützter Belegerfassung – doppelte Buchführung, automatische MWST-Berechnung und Lohnbuchhaltung, DSG-konform gehostet in der Schweiz.',
          audience: 'Schweizer KMU, Selbstständige und Treuhänder',
          functions: ['KI-Belegerfassung mit OCR', 'Automatische MWST-Berechnung (Schweiz)', 'Doppelte Buchführung & Bankabgleich', 'Lohnbuchhaltung inkl. Payslips', 'Multi-Mandanten-Fähigkeit für Treuhänder'],
        },
      },
    },
  },

  en: {
    nav: { home: 'Home', solutions: 'Solutions', services: 'What we do', references: 'References', platforms: 'Platforms', pricing: 'Pricing', cta: 'Request consultation' },
    pilot: {
      title: 'Become a pilot customer',
      subtitle: '{product} is coming soon. Sign up – we will contact you personally, and as a pilot customer you benefit from preferential conditions.',
      name: 'Name', company: 'Company', email: 'Email', phone: 'Phone', optional: '(optional)',
      product: 'Industry / product', submit: 'Send request', sending: 'Sending…',
      success: 'Thank you! We have received your request and will contact you personally.',
      error: 'Sending failed. Please try again or write to info@invictaflow.ch.',
      required: 'Please provide a name and a valid email.',
    },
    footer: {
      tagline: 'Web apps & automation for Swiss SMEs. Less paperwork, more time for your customers.',
      navigation: 'Navigation', servicesTitle: 'Services',
      servicesList: ['Web applications', 'Automation', 'Data management', 'Support'],
      notice: 'This website and the underlying software platform are developed, operated and licensed by {company}.',
      rights: 'All rights reserved.', privacy: 'Privacy', terms: 'Terms', imprint: 'Imprint', admin: 'Admin',
      close: 'Close', legalBinding: 'Note: The German version is legally binding.',
    },
    cookie: {
      title: 'Privacy & Cookies',
      text: 'We use cookies and store personal data to improve your experience. Our AI contact form uses AI services to process your inquiries. By using this website you agree to our {privacy}.',
      privacyLink: 'privacy policy', acceptAll: 'Accept all', necessary: 'Essential only', learnMore: 'Learn more',
    },
    contact: {
      title: 'Contact', subtitle: 'Our AI assistant helps you describe your project',
      infoTitle: 'Contact information', email: 'Email', phone: 'Phone', location: 'Location', country: 'Switzerland',
      responseTitle: 'Response time', responseText: 'We usually reply within 24 hours.',
    },
    notFound: { title: 'Page not found', text: 'The page you are looking for does not exist or has been moved.', home: 'Back to home' },
    projects: { more: 'Learn more', functions: 'Features', technologies: 'Technologies', liveDemo: 'View live demo' },
    services: { eyebrow: 'What we do for you', example: 'Example:' },
    pricing: { eyebrow: 'Pricing', included: "What's included?", from: 'from' },
    hero: { badgeBooking: 'New booking confirmed automatically', badgeOffer: 'Quote created – no manual work' },
    seo: {
      title: 'Software & Industry Solutions for Swiss SMEs | InvictaFlow',
      description: 'InvictaFlow builds websites, web apps and automations for Swiss SMEs, plus modular software for appointment-, course- and booking-based businesses.',
      products: {
        care: {
          title: 'InvictaCare – Physiotherapy & Practice Software Switzerland | InvictaFlow',
          description: 'Practice software for physiotherapy, therapy & massage: prescriptions, appointment booking, session counter, home exercises and MediData billing. Swiss solution, FADP-compliant.',
        },
        fit: {
          title: 'InvictaFit – Gym Management Software Switzerland | Classes & App',
          description: 'Gym management software from Switzerland: online booking, member management, memberships & credits, class schedule, check-in, TWINT – including your own studio app.',
        },
        dance: {
          title: 'InvictaDance – Dance School Software Switzerland | InvictaFlow',
          description: 'Software for dance schools: course programmes with levels & semesters, block registration, partner & children sign-up, credits & 10-class cards, events with tickets, waiting list.',
        },
        beauty: {
          title: 'InvictaBeauty – Salon Software for Hair, Beauty & Nails Switzerland | InvictaFlow',
          description: 'Commission-free salon software: online booking without an account, processing times, deposits & no-show fees, treatment records with photos & colour formulas, POS with daily closing, vouchers.',
        },
        dental: {
          title: 'InvictaDental – Dental Practice & Hygiene Software Switzerland | InvictaFlow',
          description: 'Cloud dental software: WhatsApp recall, online booking, digital medical history, FDI tooth chart, DENTOTAR & tariff 222 billing, cost estimates with digital approval.',
        },
        auto: {
          title: 'InvictaAuto – Garage & Tyre Service Software Switzerland | InvictaFlow',
          description: 'Workshop software: job orders, approval of additional work via WhatsApp with photo, vehicle file & service history, service & MFK reminders, tyre hotel with online slots, QR invoices.',
        },
      },
    },
    productPage: { other: 'More solutions' },
    finder: {
      eyebrow: 'Industry finder',
      title: 'Which industry are you in?',
      subtitle: 'Pick your industry – we take you straight to the right solution.',
      industries: {
        care: 'Physiotherapy, therapy & massage',
        fit: 'Fitness, EMS & personal training',
        dance: 'Dance school',
        beauty: 'Hair, beauty & nails',
        dental: 'Dental practice & hygiene',
        auto: 'Garage, workshop & tyre service',
      },
      other: 'A different industry?',
      otherText: 'No problem – we build your individual solution: a tailor-made web app with online booking, AI and automation for your business.',
      otherCta: 'Start a project enquiry',
    },
    form: {
      unavailableTitle: 'Contact us directly',
      unavailableText: 'The online inquiry form is currently unavailable. Send us an email or give us a call – we will get back to you within 24 hours.',
      startTitle: 'Start project inquiry',
      startText: 'Our AI assistant guides you through the inquiry step by step and only asks relevant questions.',
      consent: 'I have read and accept the {terms} and the {privacy}.',
      termsLabel: 'Terms & Conditions', privacyLabel: 'Privacy Policy',
      start: 'Start now',
      consentHint: 'Please confirm the Terms and the Privacy Policy first.',
      analyzingTitle: 'Analyzing your company …',
      analyzingText: 'We are checking the commercial register (Zefix) and your website so we can ask you the right questions.',
      momentTitle: 'One moment …', momentText: 'Your personal assistant is being prepared.',
      companyTitle: 'Tell us about your company',
      companyText: 'We look up your company in the Swiss commercial register (Zefix) and take a look at your website – so we already know your business before we talk about your idea.',
      companyNameLabel: 'Company name', companyNamePh: 'e.g. InvictaX Group GmbH',
      websiteLabel: 'Website', optional: '(optional)', websitePh: 'e.g. www.your-company.ch',
      analyzeBtn: 'Analyze company & continue', skipBtn: 'No company / private individual',
      thanksTitle: 'Thank you!', registryFound: 'found in the commercial register',
      questionLabel: 'Question', yourAnswer: 'Your answer', answerPh: 'Type your answer here...',
      processing: 'Processing answer...', next: 'Next', step: 'Step {n} of ~9',
      err503: 'The AI assistant is currently unavailable. Please contact us directly by email at info@invictaflow.ch.',
      err429: 'Too many requests. Please wait a moment and try again.',
      errGeneric: 'An error occurred. Please try again or write to us at info@invictaflow.ch.',
    },
    platforms: {
      title: 'Our Platforms',
      intro: 'All software platforms and the digital infrastructure are developed, operated and licensed by InvictaX Group GmbH.',
      audiencePrefix: 'Target audience:', trust: 'Developed, operated and licensed by InvictaX Group GmbH',
      toPlatform: 'Visit platform', ctaTitle: 'Your own platform?',
      ctaText: 'We develop tailor-made software solutions for your business – from the idea to day-to-day operation.',
      ctaBtn: 'Discuss your project',
      items: {
        'strongfit-studio': {
          category: 'SaaS & Studio Management',
          purpose: 'Complete management solution for fitness and wellness businesses. The platform digitalizes the entire studio routine – from appointment booking and customer management to subscriptions and payments.',
          audience: 'Fitness studios, personal trainers and wellness businesses in Switzerland',
          functions: ['Appointment management & online booking', 'CRM & customer management', 'AI-powered nutrition analysis', 'Subscription & package management', 'Payments (card, TWINT, SEPA)', 'Passwordless login (email code & WhatsApp)'],
        },
        'reinmove': {
          category: 'Services & AI',
          purpose: 'AI-powered quoting platform for cleaning services. Customers upload photos of their rooms – the AI analyzes the workload and delivers a transparent fixed price in under 60 seconds.',
          audience: 'Private individuals and companies in the Zurich Oberland needing move-out or maintenance cleaning',
          functions: ['AI image analysis for workload calculation', 'Fixed-price quote in under 60 seconds', 'Handover guarantee for move-out cleanings', 'Photo upload with dirt detection', 'Service area validation (ZIP radius)'],
        },
        'trucksonroad': {
          category: 'Events & Catering',
          purpose: 'Booking and inquiry platform for premium food trucks across Switzerland – with individual 24h quotes, six truck concepts and complete event coordination.',
          audience: 'Organizers of festivals, weddings, corporate events and private parties',
          functions: ['Online inquiry system with 24h quote', 'Six food truck concepts to choose from', 'Event type routing (wedding, corporate, festival, private)', 'WhatsApp and callback integration', 'Admin area for bookings'],
        },
        'bellastrada': {
          category: 'Rental & Booking',
          purpose: 'Digital rental platform for fully restored Fiat 500 Abarth classic cars – with multi-step booking flow, document verification and payment processing.',
          audience: 'Wedding couples, photographers and companies looking to rent a classic car for special occasions',
          functions: ['Multi-step booking assistant', 'Automatic account creation with document upload', 'Manual approval workflow for admins', 'Payment link (card, TWINT, bank transfer)', 'Vehicle management with availability calendar'],
        },
        'zo-werbeflaechen': {
          category: 'Out-of-Home Marketing',
          purpose: 'Marketplace for mobile advertising trailers in the Zurich Oberland. Companies rent advertising space at top locations with up to 15,000 views per day – regional companies benefit from a 50% discount.',
          audience: 'SMEs, clubs and marketing managers in the Zurich Oberland',
          functions: ['Location map with traffic frequency display', 'Automatic company verification via commercial register', 'Discount engine (ZO companies 50%, clubs free)', 'Booking with availability check', 'Print service with CMYK template generator'],
        },
        'ch-buchhaltung': {
          category: 'Accounting & SME Software',
          purpose: 'Swiss accounting software with AI-powered receipt capture – double-entry bookkeeping, automatic VAT calculation and payroll, hosted in Switzerland in compliance with the Swiss FADP.',
          audience: 'Swiss SMEs, self-employed professionals and fiduciaries',
          functions: ['AI receipt capture with OCR', 'Automatic VAT calculation (Switzerland)', 'Double-entry bookkeeping & bank reconciliation', 'Payroll incl. payslips', 'Multi-client capability for fiduciaries'],
        },
      },
    },
  },

  fr: {
    nav: { home: 'Accueil', solutions: 'Solutions', services: 'Nos services', references: 'Références', platforms: 'Plateformes', pricing: 'Tarifs', cta: 'Demander conseil' },
    pilot: {
      title: 'Devenir client pilote',
      subtitle: '{product} sera bientôt disponible. Inscrivez-vous – nous vous contacterons personnellement et, en tant que client pilote, vous bénéficierez de conditions préférentielles.',
      name: 'Nom', company: 'Entreprise', email: 'E-mail', phone: 'Téléphone', optional: '(facultatif)',
      product: 'Branche / produit', submit: 'Envoyer la demande', sending: 'Envoi en cours…',
      success: 'Merci beaucoup ! Nous avons bien reçu votre demande et vous contacterons personnellement.',
      error: 'Échec de l’envoi. Veuillez réessayer ou écrire à info@invictaflow.ch.',
      required: 'Veuillez indiquer un nom et une adresse e-mail valide.',
    },
    footer: {
      tagline: 'Applications web & automatisations pour les PME suisses. Moins de paperasse, plus de temps pour vos clients.',
      navigation: 'Navigation', servicesTitle: 'Prestations',
      servicesList: ['Applications web', 'Automatisations', 'Gestion des données', 'Support'],
      notice: 'Ce site web ainsi que la plateforme logicielle sous-jacente sont développés, exploités et licenciés par {company}.',
      rights: 'Tous droits réservés.', privacy: 'Confidentialité', terms: 'CG', imprint: 'Mentions légales', admin: 'Admin',
      close: 'Fermer', legalBinding: 'Remarque : la version allemande fait juridiquement foi.',
    },
    cookie: {
      title: 'Protection des données & cookies',
      text: 'Nous utilisons des cookies et stockons des données personnelles pour améliorer votre expérience. Notre formulaire de contact IA utilise des services d’IA pour traiter vos demandes. En utilisant ce site, vous acceptez notre {privacy}.',
      privacyLink: 'déclaration de confidentialité', acceptAll: 'Tout accepter', necessary: 'Nécessaires uniquement', learnMore: 'En savoir plus',
    },
    contact: {
      title: 'Contact', subtitle: 'Notre assistant IA vous aide à décrire votre projet',
      infoTitle: 'Informations de contact', email: 'E-mail', phone: 'Téléphone', location: 'Lieu', country: 'Suisse',
      responseTitle: 'Délai de réponse', responseText: 'Nous répondons généralement sous 24 heures.',
    },
    notFound: { title: 'Page introuvable', text: 'La page recherchée n’existe pas ou a été déplacée.', home: 'Retour à l’accueil' },
    projects: { more: 'En savoir plus', functions: 'Fonctionnalités', technologies: 'Technologies', liveDemo: 'Voir la démo live' },
    services: { eyebrow: 'Ce que nous faisons pour vous', example: 'Exemple :' },
    pricing: { eyebrow: 'Tarifs', included: 'Qu’est-ce qui est inclus ?', from: 'dès' },
    hero: { badgeBooking: 'Nouvelle réservation confirmée automatiquement', badgeOffer: 'Offre créée – sans travail manuel' },
    seo: {
      title: 'Logiciels & solutions métier pour PME suisses | InvictaFlow',
      description: 'InvictaFlow développe des sites web, applications web et automatisations pour les PME suisses, ainsi que des logiciels modulaires pour les entreprises de rendez-vous, cours et réservations.',
      products: {
        care: {
          title: 'InvictaCare – Logiciel de physiothérapie & cabinet Suisse | InvictaFlow',
          description: 'Logiciel de cabinet pour physiothérapie, thérapie & massage : ordonnances, réservation de rendez-vous, compteur de séances, exercices à domicile et facturation MediData.',
        },
        fit: {
          title: 'InvictaFit – Logiciel pour studios de fitness en Suisse | Cours & app',
          description: 'Logiciel pour studios de fitness en Suisse : réservation en ligne, gestion des membres, abonnements et crédits, planning des cours, check-in, TWINT – avec votre propre app.',
        },
        dance: {
          title: 'InvictaDance – Logiciel pour écoles de danse Suisse | InvictaFlow',
          description: 'Logiciel pour écoles de danse : programmes de cours avec niveaux & semestres, inscriptions par bloc, inscription couples & enfants, crédits & cartes de 10, événements avec billets.',
        },
        beauty: {
          title: 'InvictaBeauty – Logiciel de salon pour coiffure, beauté & ongles Suisse | InvictaFlow',
          description: 'Logiciel de salon sans commission : réservation en ligne sans compte, temps de pose, acomptes & frais de no-show, fiche de soins avec photos & formules couleur, caisse, bons cadeaux.',
        },
        dental: {
          title: 'InvictaDental – Logiciel pour cabinet dentaire & hygiène Suisse | InvictaFlow',
          description: 'Logiciel dentaire cloud : rappel par WhatsApp, réservation en ligne, anamnèse numérique, schéma dentaire FDI, facturation DENTOTAR & tarif 222, devis avec validation numérique.',
        },
        auto: {
          title: 'InvictaAuto – Logiciel pour garages & service pneus Suisse | InvictaFlow',
          description: 'Logiciel d’atelier : ordres de réparation, validation des travaux supplémentaires par WhatsApp avec photo, dossier véhicule & carnet d’entretien, rappels service & expertise, hôtel à pneus.',
        },
      },
    },
    productPage: { other: 'Autres solutions' },
    finder: {
      eyebrow: 'Trouveur de secteur',
      title: 'Dans quel secteur travaillez-vous ?',
      subtitle: 'Choisissez votre secteur – nous vous menons directement à la solution adaptée.',
      industries: {
        care: 'Physiothérapie, thérapie & massage',
        fit: 'Fitness, EMS & personal training',
        dance: 'École de danse',
        beauty: 'Coiffure, beauté & ongles',
        dental: 'Cabinet dentaire & hygiène',
        auto: 'Garage, atelier & pneus',
      },
      other: 'Un autre secteur ?',
      otherText: 'Pas de problème – nous développons votre solution individuelle : application web sur mesure avec réservation en ligne, IA et automatisation pour votre entreprise.',
      otherCta: 'Lancer une demande de projet',
    },
    form: {
      unavailableTitle: 'Contactez-nous directement',
      unavailableText: 'Le formulaire de demande en ligne est momentanément indisponible. Écrivez-nous un e-mail ou appelez-nous – nous vous répondrons sous 24 heures.',
      startTitle: 'Démarrer une demande de projet',
      startText: 'Notre assistant IA vous guide pas à pas dans votre demande et ne pose que des questions pertinentes.',
      consent: 'J’ai lu et j’accepte les {terms} et la {privacy}.',
      termsLabel: 'CG', privacyLabel: 'déclaration de confidentialité',
      start: 'Commencer',
      consentHint: 'Veuillez d’abord confirmer les CG et la déclaration de confidentialité.',
      analyzingTitle: 'Nous analysons votre entreprise …',
      analyzingText: 'Le registre du commerce (Zefix) et votre site web sont vérifiés afin de vous poser les bonnes questions.',
      momentTitle: 'Un instant …', momentText: 'Votre assistant personnel est en cours de préparation.',
      companyTitle: 'Parlez-nous de votre entreprise',
      companyText: 'Nous recherchons votre entreprise dans le registre du commerce (Zefix) et jetons un œil à votre site web – nous connaissons ainsi votre entreprise avant même de parler de votre idée.',
      companyNameLabel: 'Nom de l’entreprise', companyNamePh: 'p. ex. InvictaX Group GmbH',
      websiteLabel: 'Site web', optional: '(facultatif)', websitePh: 'p. ex. www.votre-entreprise.ch',
      analyzeBtn: 'Analyser l’entreprise & continuer', skipBtn: 'Pas d’entreprise / particulier',
      thanksTitle: 'Merci beaucoup !', registryFound: 'trouvé au registre du commerce',
      questionLabel: 'Question', yourAnswer: 'Votre réponse', answerPh: 'Saisissez votre réponse ici...',
      processing: 'Traitement de la réponse...', next: 'Suivant', step: 'Étape {n} sur ~9',
      err503: 'L’assistant IA est momentanément indisponible. Veuillez nous contacter directement par e-mail à info@invictaflow.ch.',
      err429: 'Trop de demandes. Veuillez patienter un instant et réessayer.',
      errGeneric: 'Une erreur est survenue. Veuillez réessayer ou nous écrire à info@invictaflow.ch.',
    },
    platforms: {
      title: 'Nos plateformes',
      intro: 'Toutes les plateformes logicielles et l’infrastructure numérique sont développées, exploitées et licenciées par InvictaX Group GmbH.',
      audiencePrefix: 'Public cible :', trust: 'Développé, exploité et licencié par InvictaX Group GmbH',
      toPlatform: 'Vers la plateforme', ctaTitle: 'Votre propre plateforme ?',
      ctaText: 'Nous développons des solutions logicielles sur mesure pour votre entreprise – de l’idée à l’exploitation quotidienne.',
      ctaBtn: 'Discuter du projet',
      items: {
        'strongfit-studio': {
          category: 'SaaS & Gestion de studio',
          purpose: 'Solution de gestion complète pour les centres de fitness et de bien-être. La plateforme numérise tout le quotidien du studio – de la réservation de rendez-vous à la gestion des clients, des abonnements et des paiements.',
          audience: 'Studios de fitness, coachs personnels et centres de bien-être en Suisse',
          functions: ['Gestion des rendez-vous & réservation en ligne', 'CRM & gestion des clients', 'Analyse nutritionnelle assistée par IA', 'Gestion des abonnements et forfaits', 'Paiements (carte, TWINT, SEPA)', 'Connexion sans mot de passe (code e-mail & WhatsApp)'],
        },
        'reinmove': {
          category: 'Services & IA',
          purpose: 'Plateforme de devis assistée par IA pour les services de nettoyage. Les clients téléchargent des photos de leurs pièces – l’IA analyse la charge de travail et fournit un prix fixe transparent en moins de 60 secondes.',
          audience: 'Particuliers et entreprises de l’Oberland zurichois ayant besoin de nettoyages de fin de bail ou d’entretien',
          functions: ['Analyse d’images par IA pour le calcul de la charge', 'Devis à prix fixe en moins de 60 secondes', 'Garantie de remise pour les nettoyages de fin de bail', 'Téléchargement de photos avec détection des salissures', 'Validation de la zone de service (rayon NPA)'],
        },
        'trucksonroad': {
          category: 'Événements & Catering',
          purpose: 'Plateforme de réservation et de demande pour food trucks premium dans toute la Suisse – avec offre individuelle sous 24h, six concepts de trucks et coordination complète des événements.',
          audience: 'Organisateurs de festivals, mariages, événements d’entreprise et fêtes privées',
          functions: ['Système de demande en ligne avec offre sous 24h', 'Six concepts de food trucks au choix', 'Routage par type d’événement (mariage, entreprise, festival, privé)', 'Intégration WhatsApp et rappel téléphonique', 'Espace admin pour les réservations'],
        },
        'bellastrada': {
          category: 'Location & Réservation',
          purpose: 'Plateforme de location numérique pour des Fiat 500 Abarth anciennes entièrement restaurées – avec parcours de réservation en plusieurs étapes, vérification des documents et traitement des paiements.',
          audience: 'Couples de mariés, photographes et entreprises souhaitant louer une voiture ancienne pour des occasions spéciales',
          functions: ['Assistant de réservation en plusieurs étapes', 'Création automatique de compte avec téléchargement de documents', 'Processus de validation manuel pour les admins', 'Lien de paiement (carte, TWINT, virement bancaire)', 'Gestion des véhicules avec calendrier de disponibilité'],
        },
        'zo-werbeflaechen': {
          category: 'Marketing out-of-home',
          purpose: 'Place de marché pour remorques publicitaires mobiles dans l’Oberland zurichois. Les entreprises louent des surfaces publicitaires à des emplacements de choix avec jusqu’à 15’000 contacts visuels par jour – les entreprises régionales bénéficient de 50% de rabais.',
          audience: 'PME, associations et responsables marketing de l’Oberland zurichois',
          functions: ['Carte des emplacements avec fréquence du trafic', 'Vérification automatique des entreprises via le registre du commerce', 'Moteur de rabais (entreprises ZO 50%, associations gratuites)', 'Réservation avec contrôle de disponibilité', 'Service d’impression avec générateur de gabarits CMJN'],
        },
        'ch-buchhaltung': {
          category: 'Comptabilité & Logiciel PME',
          purpose: 'Logiciel de comptabilité suisse avec saisie des justificatifs assistée par IA – comptabilité en partie double, calcul automatique de la TVA et gestion des salaires, hébergé en Suisse conformément à la LPD.',
          audience: 'PME suisses, indépendants et fiduciaires',
          functions: ['Saisie des justificatifs par IA avec OCR', 'Calcul automatique de la TVA (Suisse)', 'Comptabilité en partie double & rapprochement bancaire', 'Gestion des salaires avec fiches de paie', 'Multi-mandats pour fiduciaires'],
        },
      },
    },
  },

  it: {
    nav: { home: 'Home', solutions: 'Soluzioni', services: 'Cosa facciamo', references: 'Referenze', platforms: 'Piattaforme', pricing: 'Prezzi', cta: 'Richiedi consulenza' },
    pilot: {
      title: 'Diventare cliente pilota',
      subtitle: '{product} sarà presto disponibile. Registratevi – vi contatteremo personalmente e come cliente pilota beneficerete di condizioni preferenziali.',
      name: 'Nome', company: 'Azienda', email: 'E-mail', phone: 'Telefono', optional: '(facoltativo)',
      product: 'Settore / prodotto', submit: 'Invia richiesta', sending: 'Invio in corso…',
      success: 'Grazie mille! Abbiamo ricevuto la vostra richiesta e vi contatteremo personalmente.',
      error: 'Invio non riuscito. Riprovate o scrivete a info@invictaflow.ch.',
      required: 'Si prega di indicare un nome e un indirizzo e-mail valido.',
    },
    footer: {
      tagline: 'Web app e automazioni per PMI svizzere. Meno lavoro d’ufficio, più tempo per i vostri clienti.',
      navigation: 'Navigazione', servicesTitle: 'Servizi',
      servicesList: ['Applicazioni web', 'Automazioni', 'Gestione dati', 'Supporto'],
      notice: 'Questo sito web e la piattaforma software sottostante sono sviluppati, gestiti e concessi in licenza da {company}.',
      rights: 'Tutti i diritti riservati.', privacy: 'Privacy', terms: 'CG', imprint: 'Impressum', admin: 'Admin',
      close: 'Chiudi', legalBinding: 'Nota: la versione tedesca è giuridicamente vincolante.',
    },
    cookie: {
      title: 'Privacy & Cookie',
      text: 'Utilizziamo cookie e memorizziamo dati personali per migliorare la vostra esperienza. Il nostro modulo di contatto IA utilizza servizi di IA per elaborare le vostre richieste. Utilizzando questo sito accettate la nostra {privacy}.',
      privacyLink: 'informativa sulla privacy', acceptAll: 'Accetta tutto', necessary: 'Solo necessari', learnMore: 'Maggiori informazioni',
    },
    contact: {
      title: 'Contatto', subtitle: 'Il nostro assistente IA vi aiuta a descrivere il vostro progetto',
      infoTitle: 'Informazioni di contatto', email: 'E-mail', phone: 'Telefono', location: 'Sede', country: 'Svizzera',
      responseTitle: 'Tempo di risposta', responseText: 'Di norma rispondiamo entro 24 ore.',
    },
    notFound: { title: 'Pagina non trovata', text: 'La pagina cercata non esiste o è stata spostata.', home: 'Torna alla home' },
    projects: { more: 'Scopri di più', functions: 'Funzionalità', technologies: 'Tecnologie', liveDemo: 'Guarda la demo live' },
    services: { eyebrow: 'Cosa facciamo per voi', example: 'Esempio:' },
    pricing: { eyebrow: 'Prezzi', included: 'Cosa è incluso?', from: 'da' },
    hero: { badgeBooking: 'Nuova prenotazione confermata automaticamente', badgeOffer: 'Offerta creata – senza lavoro manuale' },
    seo: {
      title: 'Software e soluzioni di settore per PMI svizzere | InvictaFlow',
      description: 'InvictaFlow sviluppa siti web, web app e automazioni per PMI svizzere, oltre a software modulare per attività basate su appuntamenti, corsi e prenotazioni.',
      products: {
        care: {
          title: 'InvictaCare – Software per fisioterapia e studi Svizzera | InvictaFlow',
          description: 'Software per fisioterapia, terapia e massaggi: prescrizioni, prenotazione appuntamenti, contatore sedute, esercizi a casa e fatturazione tramite MediData. Soluzione svizzera.',
        },
        fit: {
          title: 'InvictaFit – Software per palestre Svizzera | Corsi, abbonamenti & app',
          description: 'Software per palestre dalla Svizzera: prenotazione online, gestione soci, abbonamenti e crediti, piano corsi, check-in, TWINT – inclusa la vostra app.',
        },
        dance: {
          title: 'InvictaDance – Software per scuole di ballo Svizzera | InvictaFlow',
          description: 'Software per scuole di ballo: programmi con livelli e semestri, iscrizione a blocchi, iscrizione coppie e bambini, crediti e tessere da 10, eventi con biglietti, lista d’attesa.',
        },
        beauty: {
          title: 'InvictaBeauty – Software per saloni: parrucchieri, estetica & nails Svizzera | InvictaFlow',
          description: 'Software per saloni senza commissioni: prenotazione online senza account, tempi di posa, acconti e penali no-show, scheda trattamenti con foto e formule colore, cassa, buoni regalo.',
        },
        dental: {
          title: 'InvictaDental – Software per studi dentistici & igiene dentale Svizzera | InvictaFlow',
          description: 'Software dentale in cloud: recall via WhatsApp, prenotazione online, anamnesi digitale, schema dentale FDI, fatturazione DENTOTAR e tariffa 222, preventivi con approvazione digitale.',
        },
        auto: {
          title: 'InvictaAuto – Software per officine & servizio gomme Svizzera | InvictaFlow',
          description: 'Software per officine: ordini di lavoro, approvazione dei lavori extra via WhatsApp con foto, scheda veicolo e libretto di servizio, promemoria service e collaudo, deposito gomme.',
        },
      },
    },
    productPage: { other: 'Altre soluzioni' },
    finder: {
      eyebrow: 'Trova il tuo settore',
      title: 'In quale settore lavori?',
      subtitle: 'Scegli il tuo settore – ti portiamo direttamente alla soluzione giusta.',
      industries: {
        care: 'Fisioterapia, terapia & massaggi',
        fit: 'Fitness, EMS & personal training',
        dance: 'Scuola di ballo',
        beauty: 'Parrucchieri, estetica & nails',
        dental: 'Studio dentistico & igiene',
        auto: 'Officina, garage & gomme',
      },
      other: 'Un altro settore?',
      otherText: 'Nessun problema – sviluppiamo la tua soluzione individuale: web app su misura con prenotazione online, AI e automazione per la tua attività.',
      otherCta: 'Avvia una richiesta di progetto',
    },
    form: {
      unavailableTitle: 'Contattateci direttamente',
      unavailableText: 'Il modulo di richiesta online non è al momento disponibile. Scriveteci un’e-mail o chiamateci – vi risponderemo entro 24 ore.',
      startTitle: 'Avvia richiesta di progetto',
      startText: 'Il nostro assistente IA vi guida passo dopo passo nella richiesta e pone solo domande pertinenti.',
      consent: 'Ho letto e accetto le {terms} e l’{privacy}.',
      termsLabel: 'CG', privacyLabel: 'informativa sulla privacy',
      start: 'Inizia ora',
      consentHint: 'Si prega di confermare prima le CG e l’informativa sulla privacy.',
      analyzingTitle: 'Stiamo analizzando la vostra azienda …',
      analyzingText: 'Stiamo verificando il registro di commercio (Zefix) e il sito web per potervi porre le domande giuste.',
      momentTitle: 'Un attimo …', momentText: 'Il vostro assistente personale è in preparazione.',
      companyTitle: 'Parlateci della vostra azienda',
      companyText: 'Cerchiamo la vostra azienda nel registro di commercio (Zefix) e diamo un’occhiata al vostro sito web – così conosciamo già la vostra impresa prima di parlare della vostra idea.',
      companyNameLabel: 'Nome dell’azienda', companyNamePh: 'es. InvictaX Group GmbH',
      websiteLabel: 'Sito web', optional: '(facoltativo)', websitePh: 'es. www.vostra-azienda.ch',
      analyzeBtn: 'Analizza azienda & continua', skipBtn: 'Nessuna azienda / privato',
      thanksTitle: 'Grazie mille!', registryFound: 'trovato nel registro di commercio',
      questionLabel: 'Domanda', yourAnswer: 'La vostra risposta', answerPh: 'Inserite qui la vostra risposta...',
      processing: 'Elaborazione della risposta...', next: 'Avanti', step: 'Passo {n} di ~9',
      err503: 'L’assistente IA non è al momento disponibile. Contattateci direttamente via e-mail a info@invictaflow.ch.',
      err429: 'Troppe richieste. Attendete un momento e riprovate.',
      errGeneric: 'Si è verificato un errore. Riprovate o scriveteci a info@invictaflow.ch.',
    },
    platforms: {
      title: 'Le nostre piattaforme',
      intro: 'Tutte le piattaforme software e l’infrastruttura digitale sono sviluppate, gestite e concesse in licenza da InvictaX Group GmbH.',
      audiencePrefix: 'Pubblico di riferimento:', trust: 'Sviluppato, gestito e concesso in licenza da InvictaX Group GmbH',
      toPlatform: 'Vai alla piattaforma', ctaTitle: 'La vostra piattaforma personale?',
      ctaText: 'Sviluppiamo soluzioni software su misura per la vostra azienda – dall’idea all’esercizio quotidiano.',
      ctaBtn: 'Parliamo del progetto',
      items: {
        'strongfit-studio': {
          category: 'SaaS & Gestione studio',
          purpose: 'Soluzione gestionale completa per centri fitness e wellness. La piattaforma digitalizza l’intera routine dello studio – dalla prenotazione degli appuntamenti alla gestione di clienti, abbonamenti e pagamenti.',
          audience: 'Palestre, personal trainer e centri benessere in Svizzera',
          functions: ['Gestione appuntamenti e prenotazione online', 'CRM e gestione clienti', 'Analisi nutrizionale basata su IA', 'Gestione abbonamenti e pacchetti', 'Pagamenti (carta, TWINT, SEPA)', 'Login senza password (codice e-mail e WhatsApp)'],
        },
        'reinmove': {
          category: 'Servizi & IA',
          purpose: 'Piattaforma di preventivi basata su IA per servizi di pulizia. I clienti caricano le foto dei loro locali – l’IA analizza il lavoro necessario e fornisce un prezzo fisso trasparente in meno di 60 secondi.',
          audience: 'Privati e aziende nell’Oberland zurighese che necessitano di pulizie di fine locazione o di manutenzione',
          functions: ['Analisi delle immagini con IA per il calcolo del lavoro', 'Preventivo a prezzo fisso in meno di 60 secondi', 'Garanzia di consegna per pulizie di fine locazione', 'Caricamento foto con rilevamento dello sporco', 'Validazione dell’area di servizio (raggio CAP)'],
        },
        'trucksonroad': {
          category: 'Eventi & Catering',
          purpose: 'Piattaforma di prenotazione e richiesta per food truck premium in tutta la Svizzera – con offerta individuale in 24 ore, sei concept di truck e coordinamento completo degli eventi.',
          audience: 'Organizzatori di festival, matrimoni, eventi aziendali e feste private',
          functions: ['Sistema di richiesta online con offerta in 24 ore', 'Sei concept di food truck tra cui scegliere', 'Smistamento per tipo di evento (matrimonio, azienda, festival, privato)', 'Integrazione WhatsApp e richiamata', 'Area admin per le prenotazioni'],
        },
        'bellastrada': {
          category: 'Noleggio & Prenotazione',
          purpose: 'Piattaforma digitale di noleggio per Fiat 500 Abarth d’epoca completamente restaurate – con processo di prenotazione a più fasi, verifica dei documenti e gestione dei pagamenti.',
          audience: 'Sposi, fotografi e aziende che desiderano noleggiare un’auto d’epoca per occasioni speciali',
          functions: ['Assistente di prenotazione a più fasi', 'Creazione automatica dell’account con caricamento documenti', 'Flusso di approvazione manuale per gli admin', 'Link di pagamento (carta, TWINT, bonifico bancario)', 'Gestione veicoli con calendario delle disponibilità'],
        },
        'zo-werbeflaechen': {
          category: 'Marketing out-of-home',
          purpose: 'Marketplace per rimorchi pubblicitari mobili nell’Oberland zurighese. Le aziende affittano spazi pubblicitari in posizioni di punta con fino a 15’000 contatti visivi al giorno – le aziende regionali beneficiano del 50% di sconto.',
          audience: 'PMI, associazioni e responsabili marketing nell’Oberland zurighese',
          functions: ['Mappa delle posizioni con frequenza del traffico', 'Verifica automatica delle aziende tramite registro di commercio', 'Motore di sconti (aziende ZO 50%, associazioni gratis)', 'Prenotazione con verifica della disponibilità', 'Servizio di stampa con generatore di modelli CMYK'],
        },
        'ch-buchhaltung': {
          category: 'Contabilità & Software PMI',
          purpose: 'Software di contabilità svizzero con registrazione dei giustificativi basata su IA – contabilità in partita doppia, calcolo automatico dell’IVA e gestione salari, ospitato in Svizzera in conformità alla LPD.',
          audience: 'PMI svizzere, lavoratori autonomi e fiduciarie',
          functions: ['Registrazione giustificativi con IA e OCR', 'Calcolo automatico dell’IVA (Svizzera)', 'Partita doppia e riconciliazione bancaria', 'Gestione salari incl. buste paga', 'Multi-mandato per fiduciarie'],
        },
      },
    },
  },

  es: {
    nav: { home: 'Inicio', solutions: 'Soluciones', services: 'Qué hacemos', references: 'Referencias', platforms: 'Plataformas', pricing: 'Precios', cta: 'Solicitar asesoría' },
    pilot: {
      title: 'Convertirse en cliente piloto',
      subtitle: '{product} estará disponible pronto. Regístrese: nos pondremos en contacto con usted personalmente y, como cliente piloto, disfrutará de condiciones preferentes.',
      name: 'Nombre', company: 'Empresa', email: 'Correo electrónico', phone: 'Teléfono', optional: '(opcional)',
      product: 'Sector / producto', submit: 'Enviar solicitud', sending: 'Enviando…',
      success: '¡Muchas gracias! Hemos recibido su solicitud y nos pondremos en contacto con usted personalmente.',
      error: 'Error al enviar. Inténtelo de nuevo o escriba a info@invictaflow.ch.',
      required: 'Indique un nombre y un correo electrónico válido.',
    },
    footer: {
      tagline: 'Aplicaciones web y automatizaciones para pymes suizas. Menos papeleo, más tiempo para sus clientes.',
      navigation: 'Navegación', servicesTitle: 'Servicios',
      servicesList: ['Aplicaciones web', 'Automatizaciones', 'Gestión de datos', 'Soporte'],
      notice: 'Este sitio web y la plataforma de software subyacente son desarrollados, operados y licenciados por {company}.',
      rights: 'Todos los derechos reservados.', privacy: 'Privacidad', terms: 'CG', imprint: 'Aviso legal', admin: 'Admin',
      close: 'Cerrar', legalBinding: 'Nota: la versión alemana es jurídicamente vinculante.',
    },
    cookie: {
      title: 'Privacidad y cookies',
      text: 'Utilizamos cookies y almacenamos datos personales para mejorar su experiencia. Nuestro formulario de contacto con IA utiliza servicios de IA para procesar sus solicitudes. Al utilizar este sitio web, acepta nuestra {privacy}.',
      privacyLink: 'política de privacidad', acceptAll: 'Aceptar todo', necessary: 'Solo necesarias', learnMore: 'Más información',
    },
    contact: {
      title: 'Contacto', subtitle: 'Nuestro asistente de IA le ayuda a describir su proyecto',
      infoTitle: 'Información de contacto', email: 'Correo electrónico', phone: 'Teléfono', location: 'Ubicación', country: 'Suiza',
      responseTitle: 'Tiempo de respuesta', responseText: 'Normalmente respondemos en un plazo de 24 horas.',
    },
    notFound: { title: 'Página no encontrada', text: 'La página que busca no existe o ha sido movida.', home: 'Volver al inicio' },
    projects: { more: 'Más información', functions: 'Funciones', technologies: 'Tecnologías', liveDemo: 'Ver demo en vivo' },
    services: { eyebrow: 'Qué hacemos por usted', example: 'Ejemplo:' },
    pricing: { eyebrow: 'Precios', included: '¿Qué está incluido?', from: 'desde' },
    hero: { badgeBooking: 'Nueva reserva confirmada automáticamente', badgeOffer: 'Oferta creada – sin trabajo manual' },
    seo: {
      title: 'Software y soluciones sectoriales para pymes suizas | InvictaFlow',
      description: 'InvictaFlow desarrolla sitios web, aplicaciones web y automatizaciones para pymes suizas, además de software modular para negocios basados en citas, cursos y reservas.',
      products: {
        care: {
          title: 'InvictaCare – Software de fisioterapia y consultas Suiza | InvictaFlow',
          description: 'Software para fisioterapia, terapia y masajes: prescripciones, reserva de citas, contador de sesiones, ejercicios en casa y facturación mediante MediData. Solución suiza.',
        },
        fit: {
          title: 'InvictaFit – Software para gimnasios Suiza | Clases y app',
          description: 'Software para gimnasios de Suiza: reservas online, gestión de socios, abonos y créditos, plan de clases, check-in, TWINT – incluida su propia app.',
        },
        dance: {
          title: 'InvictaDance – Software para escuelas de baile Suiza | InvictaFlow',
          description: 'Software para escuelas de baile: programas con niveles y semestres, inscripción por bloques, parejas y niños, créditos y bonos de 10, eventos con entradas, lista de espera.',
        },
        beauty: {
          title: 'InvictaBeauty – Software para salones de peluquería, belleza y uñas Suiza | InvictaFlow',
          description: 'Software para salones sin comisiones: reservas online sin cuenta, tiempos de aplicación, depósitos y tarifas por ausencia, ficha de tratamientos con fotos y fórmulas de color, caja, vales regalo.',
        },
        dental: {
          title: 'InvictaDental – Software para clínicas dentales e higiene dental Suiza | InvictaFlow',
          description: 'Software dental en la nube: recall por WhatsApp, reservas online, anamnesis digital, odontograma FDI, facturación DENTOTAR y tarifa 222, presupuestos con aprobación digital.',
        },
        auto: {
          title: 'InvictaAuto – Software para talleres y servicio de neumáticos Suiza | InvictaFlow',
          description: 'Software de taller: órdenes de trabajo, aprobación de trabajos extra por WhatsApp con foto, ficha del vehículo e historial de servicio, recordatorios de servicio e ITV, hotel de neumáticos.',
        },
      },
    },
    productPage: { other: 'Más soluciones' },
    finder: {
      eyebrow: 'Buscador de sectores',
      title: '¿En qué sector trabaja?',
      subtitle: 'Elija su sector y le llevamos directamente a la solución adecuada.',
      industries: {
        care: 'Fisioterapia, terapia y masajes',
        fit: 'Fitness, EMS y entrenamiento personal',
        dance: 'Escuela de baile',
        beauty: 'Peluquería, belleza y uñas',
        dental: 'Clínica dental e higiene',
        auto: 'Taller, garaje y neumáticos',
      },
      other: '¿Otro sector?',
      otherText: 'Ningún problema: desarrollamos su solución individual, una aplicación web a medida con reservas online, IA y automatización para su negocio.',
      otherCta: 'Iniciar una solicitud de proyecto',
    },
    form: {
      unavailableTitle: 'Contáctenos directamente',
      unavailableText: 'El formulario de solicitud online no está disponible en este momento. Escríbanos un correo o llámenos: le responderemos en un plazo de 24 horas.',
      startTitle: 'Iniciar solicitud de proyecto',
      startText: 'Nuestro asistente de IA le guía paso a paso por la solicitud y solo hace preguntas relevantes.',
      consent: 'He leído y acepto las {terms} y la {privacy}.',
      termsLabel: 'CG', privacyLabel: 'política de privacidad',
      start: 'Empezar ahora',
      consentHint: 'Por favor, confirme primero las CG y la política de privacidad.',
      analyzingTitle: 'Analizando su empresa …',
      analyzingText: 'Estamos comprobando el registro mercantil (Zefix) y su sitio web para hacerle las preguntas adecuadas.',
      momentTitle: 'Un momento …', momentText: 'Su asistente personal se está preparando.',
      companyTitle: 'Háblenos de su empresa',
      companyText: 'Buscamos su empresa en el registro mercantil suizo (Zefix) y echamos un vistazo a su sitio web, así conocemos su negocio antes de hablar de su idea.',
      companyNameLabel: 'Nombre de la empresa', companyNamePh: 'p. ej. InvictaX Group GmbH',
      websiteLabel: 'Sitio web', optional: '(opcional)', websitePh: 'p. ej. www.su-empresa.ch',
      analyzeBtn: 'Analizar empresa y continuar', skipBtn: 'Sin empresa / particular',
      thanksTitle: '¡Muchas gracias!', registryFound: 'encontrado en el registro mercantil',
      questionLabel: 'Pregunta', yourAnswer: 'Su respuesta', answerPh: 'Escriba aquí su respuesta...',
      processing: 'Procesando respuesta...', next: 'Siguiente', step: 'Paso {n} de ~9',
      err503: 'El asistente de IA no está disponible en este momento. Contáctenos directamente por correo a info@invictaflow.ch.',
      err429: 'Demasiadas solicitudes. Espere un momento e inténtelo de nuevo.',
      errGeneric: 'Se ha producido un error. Inténtelo de nuevo o escríbanos a info@invictaflow.ch.',
    },
    platforms: {
      title: 'Nuestras plataformas',
      intro: 'Todas las plataformas de software y la infraestructura digital son desarrolladas, operadas y licenciadas por InvictaX Group GmbH.',
      audiencePrefix: 'Público objetivo:', trust: 'Desarrollado, operado y licenciado por InvictaX Group GmbH',
      toPlatform: 'Ir a la plataforma', ctaTitle: '¿Su propia plataforma?',
      ctaText: 'Desarrollamos soluciones de software a medida para su empresa, desde la idea hasta la operación diaria.',
      ctaBtn: 'Hablar del proyecto',
      items: {
        'strongfit-studio': {
          category: 'SaaS y gestión de estudios',
          purpose: 'Solución de gestión completa para centros de fitness y bienestar. La plataforma digitaliza todo el día a día del estudio: desde la reserva de citas y la gestión de clientes hasta los abonos y pagos.',
          audience: 'Gimnasios, entrenadores personales y centros de bienestar en Suiza',
          functions: ['Gestión de citas y reservas online', 'CRM y gestión de clientes', 'Análisis nutricional con IA', 'Gestión de abonos y paquetes', 'Pagos (tarjeta, TWINT, SEPA)', 'Inicio de sesión sin contraseña (código por e-mail y WhatsApp)'],
        },
        'reinmove': {
          category: 'Servicios e IA',
          purpose: 'Plataforma de presupuestos con IA para servicios de limpieza. Los clientes suben fotos de sus habitaciones y la IA analiza el trabajo y ofrece un precio fijo transparente en menos de 60 segundos.',
          audience: 'Particulares y empresas del Oberland de Zúrich que necesitan limpiezas de mudanza o mantenimiento',
          functions: ['Análisis de imágenes con IA para calcular el trabajo', 'Presupuesto a precio fijo en menos de 60 segundos', 'Garantía de entrega en limpiezas de mudanza', 'Subida de fotos con detección de suciedad', 'Validación de la zona de servicio (radio de código postal)'],
        },
        'trucksonroad': {
          category: 'Eventos y catering',
          purpose: 'Plataforma de reservas y solicitudes de food trucks premium en toda Suiza, con oferta individual en 24 h, seis conceptos de trucks y coordinación completa de eventos.',
          audience: 'Organizadores de festivales, bodas, eventos corporativos y fiestas privadas',
          functions: ['Sistema de solicitud online con oferta en 24 h', 'Seis conceptos de food truck para elegir', 'Clasificación por tipo de evento (boda, empresa, festival, privado)', 'Integración de WhatsApp y devolución de llamada', 'Área de administración de reservas'],
        },
        'bellastrada': {
          category: 'Alquiler y reservas',
          purpose: 'Plataforma digital de alquiler de Fiat 500 Abarth clásicos totalmente restaurados, con proceso de reserva en varios pasos, verificación de documentos y gestión de pagos.',
          audience: 'Parejas de novios, fotógrafos y empresas que desean alquilar un coche clásico para ocasiones especiales',
          functions: ['Asistente de reserva en varios pasos', 'Creación automática de cuenta con subida de documentos', 'Flujo de aprobación manual para administradores', 'Enlace de pago (tarjeta, TWINT, transferencia bancaria)', 'Gestión de vehículos con calendario de disponibilidad'],
        },
        'zo-werbeflaechen': {
          category: 'Marketing exterior',
          purpose: 'Mercado de remolques publicitarios móviles en el Oberland de Zúrich. Las empresas alquilan espacios publicitarios en ubicaciones de primer nivel con hasta 15.000 impactos visuales al día; las empresas regionales se benefician de un 50% de descuento.',
          audience: 'Pymes, asociaciones y responsables de marketing del Oberland de Zúrich',
          functions: ['Mapa de ubicaciones con frecuencia de tráfico', 'Verificación automática de empresas vía registro mercantil', 'Motor de descuentos (empresas ZO 50%, asociaciones gratis)', 'Reserva con comprobación de disponibilidad', 'Servicio de impresión con generador de plantillas CMYK'],
        },
        'ch-buchhaltung': {
          category: 'Contabilidad y software para pymes',
          purpose: 'Software de contabilidad suizo con captura de comprobantes mediante IA: contabilidad de partida doble, cálculo automático del IVA y gestión de nóminas, alojado en Suiza conforme a la LPD.',
          audience: 'Pymes suizas, autónomos y fiduciarias',
          functions: ['Captura de comprobantes con IA y OCR', 'Cálculo automático del IVA (Suiza)', 'Partida doble y conciliación bancaria', 'Nóminas incl. recibos de sueldo', 'Multicliente para fiduciarias'],
        },
      },
    },
  },
};

const resolvePath = (obj, key) => key.split('.').reduce((o, k) => (o == null ? undefined : o[k]), obj);

export const translate = (lang, key) => {
  const v = resolvePath(UI[lang], key);
  if (v !== undefined) return v;
  const fallback = resolvePath(UI.de, key);
  return fallback !== undefined ? fallback : key;
};

export const detectLang = () => {
  try {
    const urlLang = new URLSearchParams(window.location.search).get('lang');
    if (urlLang && SUPPORTED_LANGS.includes(urlLang)) return urlLang;
    const stored = localStorage.getItem('site_lang');
    if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
    const nav = (navigator.language || 'de').slice(0, 2).toLowerCase();
    return SUPPORTED_LANGS.includes(nav) ? nav : 'de';
  } catch {
    return 'de';
  }
};
